import { PayloadAction } from '@reduxjs/toolkit';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { ProductState, ProductType } from 'store/product/types';

const setPersonalisedProductReducer = (
  state: ProductState,
  action: PayloadAction<AppBundle.Api.Entity.App.V1.IProductPage>,
) => {
  state.personalisedProduct = action.payload;
  state.productType = ProductType.personalized;
};

export default setPersonalisedProductReducer;
